<!-- `data-field-uuid` is how the vehicle form's wizard finds a field to scroll
     to, focus and ring. Currency fields render through this component (a value
     + a pencil) instead of `app-form-input`, which was the only place setting
     the attribute — so every one of them was a step the wizard walked the
     dealer to and then left completely unmarked (BRIEFD-7189). On the root, so
     the cue survives the swap to the editor when the pencil is clicked. -->
<div [style.display]="isHidden ? 'none' : 'block'"
     [attr.data-field-uuid]="field?.fieldUuid">
  @if (!hideLabel) {
    <label class="text-grayDark text-xs">
      @if (field.type !== 'vehicle_model' && field.config.label) {
        <span class="leading-normal">{{ field.config.label }}</span>
      }
      @if (field.config.description) {
        <app-tooltip class="ml-1" [content]="field.config.description"></app-tooltip>
      }
    </label>
  }

  @if (fieldEditMap.has(field.fieldUuid)) {
    @let fieldEdit = fieldEditMap.get(field.fieldUuid);
    <div class="flex flex-row" [style.min-width]="minWidth !== 'undefined' ? minWidth : 'auto'">
      <div class="grow">
        <app-field-input [field]="fieldEdit.updatedField"
                         [hideLabel]="true"
                         [disabled]="isSaving"
                         [formGroup]="showPriceChangeDescription ? fieldEdit.formGroup : (formGroup || fieldEdit.formGroup)"></app-field-input>

        @if (showPriceChangeDescription) {
          <app-price-change-reason-selector
            [formGroup]="fieldEdit.formGroup"
            [disabled]="isSaving"
            [isInitialPrice]="originalFieldValue === null || originalFieldValue === 0"
            [choices]="field.config?.priceChangeReasonChoices">
          </app-price-change-reason-selector>
        }
      </div>
      <div class="block flex flex-row content-center justify-center">
        <button
          data-test="save-edit-button"
          class="btn p-2 border-transparent text-base text-gray shadow-none mt-1 text-primary hover:text-primary fadeInFadeOut"
          style="border: transparent !important;"
          [disabled]="isSaving || fieldEdit.formGroup.controls[field.fieldUuid].invalid || (showPriceChangeDescription && fieldEdit.formGroup.invalid)"
          type="button" (click)="saveEdit(field)"><i
          class="fas fa-check-circle"></i></button>
        <button
          class="btn p-2 border-transparent text-base text-gray shadow-none mt-1 text-red hover:text-redHover fadeInFadeOut"
          style="border: transparent !important;"
          [disabled]="isSaving"
          type="button" (click)="cancelEdit(field)"><i
          class="fas fa-times-circle"></i></button>
      </div>
    </div>
  } @else {
    <div class="text-grayDark" [ngClass]="getClass()"
         [attr.data-field]="field?.fieldUuid"
         [attr.data-typeId]="field?.config?.typeId">
      <div class="flex flex-row">
        <div class="flex items-center"
             [ngClass]="{'font-bold': !removeBoldFromValue, 'grow': expandToFullSize, 'text-black': removeBoldFromValue}">
          <app-field-table-value [field]="field"></app-field-table-value>
          @if (field.value === null) {
            <span>{{ replaceNullValueWith }}</span>
          }
        </div>
        @if (isEditable) {
          <div class="relative pl-2">
            <button class="btn border-transparent text-gray shadow-none btn-sm hover:text-grayDark"
                    data-test="open-field-value-button"
                    type="button" (click)="editOrOpenEditDialog(field)"
                    [attr.tabIndex]="0"><i class="fas fa-pen"></i>
            </button>
          </div>
        }
      </div>
    </div>

    @if (formGroup) {
      <app-field-errors [control]="formGroup.controls[this.field.fieldUuid]" [hasToBeTouched]="false"></app-field-errors>
    }
  }
</div>
